import type { PjElement } from "../components";

/** Describes how a routed path resolves to a component to render. */
export interface Route {
  /** The `location.pathname` (case-insensitive) that resolves to this route. */
  pathName: string;
  /** The page name that appears in the `<title>` and `<h1>` on a page. */
  title: string;
  /**
   * Lazy-loads the component. Chain `import().then()`. The service worker should **not** import
   * the module that contains the component, so this must not be imported into the module scope.
   */
  loadComponent: () => Promise<PjElement>;
}

/**
 * Defines the routes for the application.
 *
 * The routes are used in various places:
 *  - The pj-app-nav element utilizes this const to produce the <a> links in the site header
 *  - The service worker determines if it should serve `index.html` in response to a request by utilizing this array.
 * */
export const APP_ROUTES: readonly Route[] = [
  {
    pathName: "/",
    title: "Search",
    loadComponent: () =>
      import("../../features/search/pj-search-prayers-page-element").then(
        (p) => new p.PjSearchPrayersPageElement(),
      ),
  },
  {
    pathName: "/request",
    title: "Request",
    loadComponent: () =>
      import("../../features/edit/pj-request-page-element").then(
        (p) => new p.PjRequestPageElement(),
      ),
  },
  {
    pathName: "/about",
    title: "About",
    loadComponent: () =>
      import("@/features/about/pj-about-page-element").then((p) => new p.PjAboutPageElement()),
  },
  {
    pathName: "/settings",
    title: "Advanced",
    loadComponent: () =>
      import("@/features/settings/pj-settings-page-element").then(
        (p) => new p.PjSettingsPageElement(),
      ),
  },
];
